import * as generic from './generic.json'
import * as loginForm from './login-form.json'
import * as companyForm from './company-form.json'
import * as pagination from './pagination.json'
import * as card from './card.json'
import * as forgotPasswordForm from './forgot-password-form'
import * as resetPasswordForm from './reset-password-form'
import * as invoice from './invoice'
import * as datepicker from './datepicker'
import * as serviceAndContact from './service-and-contact'
import * as order from './order'
import * as orderItem from './order-item'
import * as orderReplacementCard from './order-replacement-card'
import * as orderTerminateCard from './order-terminate-card'
import * as tlsProduct from './tls-product'
import * as rorProduct from './ror-product'
import * as trip from './trip'
import * as form from './form'

export default {
  generic,
  loginForm,
  companyForm,
  pagination,
  card,
  forgotPasswordForm,
  resetPasswordForm,
  invoice,
  datepicker,
  serviceAndContact,
  order,
  orderItem,
  orderReplacementCard,
  orderTerminateCard,
  tlsProduct,
  rorProduct,
  trip,
  form
}



// WEBPACK FOOTER //
// ./src/locale/nl/index.js